import { CONSTANTS } from '../game.js';

/**
 * 衝突検出と処理を担当するクラス
 */
export class CollisionManager {
    /**
     * @param {Phaser.Scene} scene - シーン
     * @param {Object} callbacks - コールバック関数のオブジェクト
     * @param {Function} [callbacks.onWeightTargetCollision] - 錘と的の衝突時のコールバック
     */
    constructor(scene, callbacks = {}) {
        this.scene = scene;
        this.callbacks = callbacks;
        this.collisionListener = null;
    }

    /**
     * 必要なコンポーネントを設定
     */
    setup() {
        // 衝突イベントの設定
        this.setupCollisionEvents();
    }

    /**
     * 衝突イベントの設定
     */
    setupCollisionEvents() {
        // 既存のリスナーがあれば削除
        if (this.collisionListener) {
            this.scene.matter.world.off('collisionstart', this.collisionListener);
        }
        
        // 衝突リスナーを作成して保存（後でクリーンアップできるように）
        this.collisionListener = (event) => {
            const pairs = event.pairs;
            
            for (let i = 0; i < pairs.length; i++) {
                const bodyA = pairs[i].bodyA;
                const bodyB = pairs[i].bodyB;
                
                // 錘と的の衝突判定
                if ((bodyA.label === 'weight' && bodyB.label === 'target') || 
                    (bodyA.label === 'target' && bodyB.label === 'weight')) {
                    
                    const weightBody = bodyA.label === 'weight' ? bodyA : bodyB;
                    const targetBody = bodyA.label === 'target' ? bodyA : bodyB;
                    
                    // コールバック関数を呼び出す
                    if (this.callbacks.onWeightTargetCollision) {
                        this.callbacks.onWeightTargetCollision(targetBody);
                    }
                }
            }
        };
        
        // 衝突イベントリスナーを登録
        this.scene.matter.world.on('collisionstart', this.collisionListener);
    }

    /**
     * リソースのクリーンアップ
     */
    cleanup() {
        // 衝突イベントのリスナーを明示的に削除
        if (this.collisionListener) {
            this.scene.matter.world.off('collisionstart', this.collisionListener);
            this.collisionListener = null;
        }
    }
}
